module.exports = __webpack_public_path__ + "cbb404699d1b1889a14759c008ed776a.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Bold-Oblique.woff
// module id = 408
// module chunks = 0